import type { StaticTextResource } from '../keys'

export const ne: StaticTextResource = {
  'schedule.dueToday': 'आज सम्म {{time}}',
  'schedule.dueTomorrow': 'भोलि सम्म {{time}}',
  'schedule.durationRange':
    '{{start}} - {{end}} (दिन {{currentDay}}/{{days}} दिन)',
  'editReport.defaultPageName': 'पृष्ठ {{n}}',
  'editReport.defaultSectionName': 'खण्ड',
  'editReport.defaultRepeatSectionName': 'दोहोरिने खण्ड',
}
